/** 
 * 自动拆分/手动拆分
*/

import { keepTwoDecimal } from 'common/js/util'
import InventoryReconciliation from "models/inventory-reconciliation";
export default {
  data() {
    return {
      projectId: null,
      projectName: null,
      billHeadId: null,
      billHeadName: null,
      // 账单id集合
      billIds: [],
      
      // 自动/手动拆分预览标题
      titleSplit: '自动拆分预览',
      previewDialog: false,
      previewList: [],
      // 应收自动拆分预览标题
      previewTitleList: [
        { prop: 'invoicieNumber', label: '发票编号', width: '100' },
        // { prop: 'billNumber', label: '所属账单编号', width: '140' },
        { prop: 'billHeadName', label: '抬头', width: '170' },
        { prop: 'agentBusinessVal', label: '代收代付', width: '' },
        { prop: 'currencyVal', label: '币制', width: '' },
        { prop: 'price', label: '金额', width: '' }
      ],
      // 应付自动拆分预览标题
      payPreviewTitleList: [
        { prop: 'invoicieNumber', label: '发票编号', width: '100' },
        { prop: 'billHeadName', label: '抬头', width: '170' },
        { prop: 'agentBusinessVal', label: '代收代付', width: '' },
        { prop: 'currencyVal', label: '币制', width: '' },
        { prop: 'price', label: '金额', width: '' }
      ],


      // 手动拆分弹框开关
      generateInvoicedDialog: false,
      // 弹框标题名称
      title: '手动拆分',
      // 科目明细表头
      subjectTableTitle: [
        { prop: 'feeName', label: '科目明细', width: '' },
        { prop: 'entryExitNumber', label: '进出仓编号/提单号', width: '170' },
        { prop: 'billHeadName', label: '抬头', width: '' },
        { prop: 'agentBusinessVal', label: '代收代付', width: '100' },
        { prop: 'currencyVal', label: '币制', width: '60' },
        { prop: 'price', label: '金额', width: '' }
      ],
      paySubjectTableTitle: [
        { prop: 'feeName', label: '科目明细', width: '' },
        { prop: 'entryExitNumber', label: '进出仓编号/提单号', width: '170' },
        { prop: 'projectName', label: '项目名称', width: '150' },
        { prop: 'agentBusinessVal', label: '代收代付', width: '100' },
        { prop: 'currencyVal', label: '币制', width: '60' },
        { prop: 'price', label: '金额', width: '' }
      ],
      // 拆分后的列表
      splitList: []
    }
  },
  created() {
  },
  methods: {
    // 自动拆分预览列表
    initSplitPerviewList() {
      let billIds = this.billIds
      let projectId = this.projectId
      let projectName = this.projectName
      let accountsType = this.accountsType
      let data = {
        billIds,
        projectId,
        projectName,
        accountsType
      }
      InventoryReconciliation.getAutoSplitPreviewList(data).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.invoiceNumber = value.invoiceNumber ? value.invoiceNumber : '';
            // obj.billNumber = this.baseInfoObj.billNumber;
            obj.billHeadId = value.billHeadId;
            obj.billHeadName = value.billHead ? value.billHead.name : ''
            obj.price = value.price;
            obj.currency = value.currency;
            obj.currencyVal = this.currencySystemObj[value.currency];
            obj.agentBusiness = value.agentBusiness;
            obj.agentBusinessVal = value.agentBusiness ? '是' : '否';
            tableData.push(obj);
          });
          this.previewList = tableData;
          this.previewDialog = true
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @description 自动拆分
    */
    autoSplit() {
      if (this.billIds.length === 0) return this.$message.error('请先选账单')
      this.titleSplit = '自动拆分预览'
      this.initSplitPerviewList()
    },

    onClosePreviewDialog() {
      this.previewDialog = false
    },

    /** 
     * @description 保存预览
    */
    onSavePreview() {
      if (this.titleSplit === '自动拆分预览') {
        let billIds = this.billIds
        let projectId = this.projectId
        let projectName = this.projectName
        let billHeadId = this.billHeadId
        let billHeadName = this.billHeadName
        let accountsType = this.accountsType
        let data
        if (this.accountsType === 1) {
          data = {
            billIds,
            projectId,
            projectName,
            accountsType
          }
        } else {
          data = {
            billIds,
            billHeadId,
            billHeadName,
            accountsType
          }
        }
        InventoryReconciliation.postAutoSplit(data).then(res => {
          if (res.success) {
            this.$message.success('自动拆分成功');
            this.onClosePreviewDialog()
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        let arr = []
        this.splitList.map(i => {
          let obj = {}
          obj.accountsType = this.accountsType
          obj.projectId = this.projectId
          obj.projectName = this.projectName
          obj.orderFeeDetailList = []
          i.subjectTableData.map(j => {
            obj.billHeadId = j.billHeadId
            obj.currency = j.currency
            obj.agentBusiness = j.agentBusiness;

            let obj2 = {}
            obj2.keyword = j.keyword
            obj2.billId = j.billId
            obj2.feeName = j.feeName
            obj2.price = j.price
            obj2.isAddService = j.isAddService
            obj2.orderFeeId = j.orderFeeId
            obj2.orderType = j.orderType
            obj2.orderNo = j.orderNo
            obj2.inboundOrderNo = j.inboundOrderNo
            obj2.outboundOrderNo = j.outboundOrderNo
            obj.orderFeeDetailList.push(obj2)
          })
          arr.push(obj)
        })
        InventoryReconciliation.postHandMovementSplit(arr).then(res => {
          if (res.success) {
            this.$message.success('手动拆分成功');
            this.onClosePreviewDialog()
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    /** 
     * @description 手动拆分
    */
    handMovementSplit() {
      if (this.billIds.length === 0) return this.$message.error('请先选账单')
      this.generateInvoicedDialog = true
    },


    /** 
     * @description 关闭手动拆分预览
    */
    onCloseGenerateInvoiced() {
      this.generateInvoicedDialog = false
    },

    /** 
     * @description 打开手动拆分预览
     * @param {array} list 手动拆分列表
    */
    onSaveGenerateInvoiced(list) {
      this.splitList = list
      let arr = []
      list.map(i => {
        let obj = {}
        let price = 0
        obj.invoiceNumber = '';
        // obj.billNumber = this.baseInfoObj.billNumber;
        i.subjectTableData.map(value => {
          obj.entryExitNumber = value.entryExitNumber;
          obj.billHeadId = value.billHeadId;
          obj.billHeadName = value.billHeadName;
          obj.projectId = value.projectId;
          obj.projectName = value.projectName;
          obj.currency = value.currency;
          obj.currencyVal = value.currencyVal;
          obj.agentBusiness = value.agentBusiness;
          obj.agentBusinessVal = value.agentBusinessVal;
          price += value.price
        })
        obj.price = keepTwoDecimal(price);
        arr.push(obj);
      })
      this.previewList = arr
      this.onCloseGenerateInvoiced()
      this.titleSplit = '手动拆分预览'
      this.previewDialog = true
    }
  }
}